import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import LogoutIcon from '@mui/icons-material/Logout'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Avatar } from '~/components/Atoms/Avatar'
import { Button } from '~/components/Atoms/Button'
import { ContextMenu } from '~/components/Atoms/ContextMenu'
import { LanguageSelector } from '~/components/Molecules/LanguageSelector'
import { HOST, NAV_LINKS } from '~/constants'

import { clearTokens } from '~/lib/auth-tokens'

export function Header({ title }: { title: string }) {
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const theme = useTheme()
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <Box display="flex" justifyContent="space-between" flexDirection="row">
      <Typography color={theme.palette.primary.main} variant="h2">
        {title}
      </Typography>
      <Box display="flex" gap={theme.spacing.M}>
        <a href={HOST + '/users/sign_in'} target="_blank" rel="noreferrer">
          <Button variant="outlined" label={t('common:moodworkButton')} endIcon={<OpenInNewIcon />} />
        </a>
        <LanguageSelector />
        <ButtonBase
          onClick={(event: MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget)
            setOpen(!open)
          }}
          sx={{
            border: `0.5px solid ${theme.palette.border.main}`,
            borderRadius: theme.radius.full,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          <Box display="flex" padding={theme.spacing.M} gap={theme.spacing.M}>
            <Avatar />
            <KeyboardArrowDownIcon />
          </Box>
        </ButtonBase>
        <ContextMenu
          open={open}
          onClose={() => {
            setOpen(false)
          }}
          anchorEl={anchorEl}
        >
          <MenuItem
            sx={{
              borderRadius: theme.radius.M,
              '&:hover': {
                backgroundColor: theme.palette.primary.hover,
              },
            }}
            onClick={() => {
              clearTokens()
              navigate(NAV_LINKS.SIGNIN.to, { replace: true })
            }}
          >
            <Box display="flex" gap={theme.spacing.M} alignItems="center">
              <LogoutIcon />
              <Typography variant="body">{t('common:logout')}</Typography>
            </Box>
          </MenuItem>
        </ContextMenu>
      </Box>
    </Box>
  )
}
